import React, { useState } from 'react';
import styles from '../../Dashboards.module.css';

/**
 * Text input for extension dashboard settings
 */
export default ({ panel, setting, updatePanel, className, title }) => {
  const path = ['settings', setting.key];

  const [value, setValue] = useState(String(panel.getIn(path)) === 'true');

  const handleChange = event => {
    const value = event.target.checked;
    setValue(value);
    updatePanel(panel.setIn(path, value));
  };

  return (
    <label>
      <input
        type='checkbox'
        checked={value}
        onChange={handleChange}
        className={styles.PanelConfigurationCheckboxInput}
      />
      <span className={styles.PanelConfigurationCheckboxSpan}>{title}</span>
    </label>
  );
};
